import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearPatients } from "../../slices/patientSlice";
import { clearUser } from "../../slices/userSlice";
import { clearToken } from "../../slices/authSlice";
import { rootApi } from "../../api/rootApi";
import { clearDevToolsUnlock } from "../../utils/disableDevTools";
import "./Navbar.css";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showMrcCard, setShowMrcCard] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Function to check authentication state
  const checkAuth = () => {
    const authToken = localStorage.getItem("authToken");
    return !!authToken;
  };

  // Function to check if patientMrno and authToken are present in local storage
  const checkMrcCard = () => {
    const authToken = localStorage.getItem("authToken");
    const patientMrno = localStorage.getItem("patientList");
    return !!authToken && !!patientMrno;
  };

  // Update authentication state on mount and at regular intervals
  useEffect(() => {
    setIsAuthenticated(checkAuth());
    setShowMrcCard(checkMrcCard());

    // Poll localStorage every 500ms to ensure UI updates without refreshing
    const interval = setInterval(() => {
      setIsAuthenticated(checkAuth());
      setShowMrcCard(checkMrcCard());
    }, 500);

    return () => clearInterval(interval); // Cleanup the interval on unmount
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false); // Close the menu when clicked outside
  };

  const handleSignOut = () => {
    // Clear Redux slices
    dispatch(clearPatients());
    dispatch(clearUser());
    dispatch(clearToken());
    clearDevToolsUnlock();
    // Reset RTK Query cache so stale patient-list is not served on next sign-in
    dispatch(rootApi.util.resetApiState());
    // Clear any remaining localStorage keys
    localStorage.clear();
    setIsAuthenticated(false);
    setShowMrcCard(false);
    navigate("/");
  };

  const [resetKey, setResetKey] = useState(0); // Key for resetting DoctorList

  const handleResetDoctorList = () => {
    setResetKey((prevKey) => prevKey + 1); // Increment key to force re-mount
  };

  return (
    <nav className="navbar">
      <div className="nav-left">
        <button className="menu-toggle" onClick={toggleMenu}>
          &#9776; {/* Hamburger Icon */}
        </button>

        <div
          className={`nav-links ${isMenuOpen ? "open" : ""}`}
          onClick={closeMenu}
        >
          <Link to="/" className="nav-link">
            Home
          </Link>
          <Link
            to="/doctors"
            className="nav-link"
            onClick={handleResetDoctorList}
          >
            Doctors
          </Link>
          <a
            href="https://shalamarhospital.org.pk/donate-now/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            Donate Now
          </a>
          <Link to="/contact" className="nav-link">
            Contact Us
          </Link>
          <Link to="/apptInstructions" className="nav-link">
            Appointment Instructions
          </Link>
          {/* MRC Card link appears in mobile menu only */}
          {showMrcCard && (
            <Link to="/mrc-card" className="nav-link mobile-only-mrc">
              MRC Card
            </Link>
          )}
        </div>
      </div>

      {/* Center Logo */}
      <div className="nav-logo">
        <div className="logo-placeholder">
          <img src={require("../../assets/images/logo1.png")} alt="Main Logo" />
        </div>
      </div>

      {/* Right section with MRC Card and Sign In/Out */}
      <div className="nav-right">
        {/* MRC Card link visible on desktop only */}
        {showMrcCard && (
          <Link to="/mrc-card" className="mrc-card-link desktop-only-mrc">
            MRC Card
          </Link>
        )}

        {/* Dynamic Sign In/Sign Out Buttons */}
        {!isAuthenticated ? (
          <Link to="/signin" className="nav-button">
            Sign In
          </Link>
        ) : (
          <button onClick={handleSignOut} className="nav-button signout-button">
            Sign Out
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
